module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "finish-time"
  }, [_vm._m(0), _c('div', {
    staticClass: "overlay"
  }, [_c('span', [_c('animated-number', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.min),
      expression: "min"
    }],
    attrs: {
      "time": 800,
      "pad": 2,
      "number": _vm.min
    }
  })], 1), _c('span', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('span', [_c('animated-number', {
    attrs: {
      "time": 800,
      "pad": 2,
      "number": _vm.sec
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "underlay"
  }, [_c('span', [_vm._v("00")]), _c('span', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('span', [_vm._v("00")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-558221c7"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/finish-time/FinishTime.vue
// module id = 445
// module chunks = 1